import React from "react";

import { templates, CSRFToken } from "@reactivated";

import { Layout } from "@client/components/Layout";
import { Button } from "@client/shadcn/ui/button";
import { Label } from "@client/shadcn/ui/label";


export const Template = (props: templates.LoginPage) => (
    <Layout title="Login">
        <div className="flex items-center min-h-screen px-4 py-12 sm:px-6 md:px-8 lg:px-12 xl:px-16">
            <div className="flex flex-col items-center w-full gap-6">
                <Label className="text-4xl font-bold tracking-tighter sm:text-5xl">Login to continue</Label>
                <Label>You will be redirected to the OUP Single Sign On page.</Label>
                <form
                    method="POST"
                    action="/accounts/auth0rbac/login/"
                >
                    <CSRFToken />
                    <Button type="submit" variant="secondary" size="lg">Continue</Button>
                </form>
            </div>
        </div>
    </Layout>
);
